// src/redux/actions/reviewActions.js
import axios from 'axios';
import { REVIEWS_REQUEST, REVIEWS_SUCCESS, REVIEWS_FAILURE } from '../Action-types';

const API_URL = `${process.env.REACT_APP_API_URL}/api/review`;

export const fetchReviews = () => async (dispatch) => {
  dispatch({ type: REVIEWS_REQUEST }); // 🟡 loading = true

  try {
    const response = await axios.get(API_URL);

    dispatch({
      type: REVIEWS_SUCCESS,
      payload: response.data.reviews || response.data || [],
    });
  } catch (error) {
    dispatch({
      type: REVIEWS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};
